import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from './LanguageSwitcher';
import { THERAPIST_LOGO } from '../../media';

export default function Footer() {
  const { t, i18n } = useTranslation();

  return (
    <footer className="bg-canvas border-t border-sage/10">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {/* Brand */}
          <div>
            <img
              src={THERAPIST_LOGO}
              alt="Mirela Logo"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-xs uppercase tracking-widest text-sage font-inter font-medium mb-3">
              {t('footer.badge')}
            </p>
            <p className="text-sm text-text-muted font-inter leading-relaxed max-w-xs">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-charcoal font-inter font-semibold mb-5">
              {t('footer.navTitle')}
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { labelKey: 'footer.about', path: '/' },
                { labelKey: 'footer.services', path: '/services' },
                { labelKey: 'footer.credentials', path: '/credentials' },
                { labelKey: 'footer.contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <NavLink
                    to={link.path}
                    className="text-sm text-text-muted font-inter hover:text-sage transition-colors duration-200 cursor-pointer"
                  >
                    {t(link.labelKey)}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Affiliations */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-charcoal font-inter font-semibold mb-5">
              {t('footer.affiliations')}
            </h4>
            <p className="text-sm text-text-muted font-inter mb-1">{t('footer.iga')}</p>
            <p className="text-sm text-text-muted font-inter mb-6">{t('footer.igaProgram')}</p>
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2 text-sm text-text-muted font-inter">
                <i className="ri-map-pin-line text-sage" />
                <span>{t('footer.location')}</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-text-muted font-inter">
                <i className="ri-translate-2 text-sage" />
                <span>{t('footer.languages')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-sage/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-text-muted font-inter">{t('footer.copyright')}</p>

          {/* Interactive language switcher in footer */}
          {/*<div className="flex items-center gap-2">*/}
          {/*  {SUPPORTED_LANGUAGES.map((lang, idx) => (*/}
          {/*    <span key={lang.code} className="flex items-center gap-2">*/}
          {/*      <button*/}
          {/*        type="button"*/}
          {/*        onClick={() => i18n.changeLanguage(lang.code)}*/}
          {/*        className={`text-xs font-inter font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap*/}
          {/*          ${i18n.language === lang.code || i18n.language.startsWith(lang.code)*/}
          {/*            ? 'text-beige'*/}
          {/*            : 'text-text-muted hover:text-charcoal'*/}
          {/*          }`}*/}
          {/*      >*/}
          {/*        {lang.short}*/}
          {/*      </button>*/}
          {/*      {idx < SUPPORTED_LANGUAGES.length - 1 && (*/}
          {/*        <span className="text-sage/20 select-none">|</span>*/}
          {/*      )}*/}
          {/*    </span>*/}
          {/*  ))}*/}
          {/*</div>*/}
        </div>
      </div>
    </footer>
  );
}
